<template>
  <div>
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="editedMember.name"
                label="Name"
                required
                :rules="nameRules"
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                :readonly="editedMember && editedMember.table == 'users'"
                v-model="editedMember.email"
                label="Email [Optional]"
                type="email"
                :rules="emailRules"
              />
            </v-col>

            <v-col cols="12" sm="6">
              <v-select
                v-model="editedMember.role"
                :items="roleOptions"
                label="Role In First Group [Required]"
                item-text="text"
                item-value="value"
                return-object
              />
            </v-col>

            <v-col cols="12" sm="6">
              <v-text-field
                v-model="editedMember.id_number"
                label="ID Number [Optional]"
              />
            </v-col>

            <v-col cols="12">
              <v-select
                chips
                v-model="editedMember.groups"
                :items="groups"
                label="Groups"
                item-text="name"
                item-value="id"
                multiple
                return-object
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn color="blue darken-1" text @click="closeDialog()">
          Cancel
        </v-btn>
        <v-btn color="blue darken-1" text @click="saveMember">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    editedMember: {
      default: () => ({}),
    },
    groups: {
      default: () => [],
    },
  },
  computed: {
    formTitle() {
      return this.editedMember && this.editedMember.id
        ? "Edit " + this.editedMember.name
        : "Create New Member";
    },
    isFormValid() {
      // &&
      //   this.editedMember.email &&
      //   /.+@.+\..+/.test(this.editedMember.email)
      return (
        this.editedMember.name &&
        this.editedMember.name.length >= 2 &&
        this.editedMember.role
      );
    },
  },

  data() {
    return {
      roleOptions: [
        { text: "Admin", value: "8" },
        { text: "Chairperson", value: "9" },
        { text: "Director", value: "11" },
        { text: "Principal", value: "12" },
        { text: "Staff", value: "5" },
        { text: "Parent or Guardian", value: "3" },
        { text: "SGB Chairperson", value: "7" },
        { text: "SGB Member", value: "4" },
        { text: "Owner", value: "11" },
        { text: "Moderator", value: "5" },
        { text: "Member", value: "2" },
        { text: "Treasurer", value: "13" },
        { text: "Secretary", value: "6" },
        { text: "Guest", value: "1" },
        { text: "CEO", value: "14" },
        { text: "Manager", value: "10" },
      ],

      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length >= 2) || "Name must be at least 2 characters",
      ],

      emailRules: [
        (v) => !!v || "Email is required",
        (v) => /.+@.+\..+/.test(v) || "Email must be valid",
      ],
    };
  },
  methods: {
    closeDialog() {
      this.$emit("close-dialog");
    },
    saveMember() {
      if (!this.isFormValid) {
        this.$toast.error("Name and Role Fields Required!");
        return false;
      }
      this.$emit("save-member", this.editedMember);
    },
  },
};
</script>
